import React, { useEffect, useState } from 'react';
import { getCookie, clearQueryParams, getUserCases,  getExpireDate, getCurrentUser, getAppUser, getAppIntegration} from '../../functions/utils'; // Import the utility function
import {getImportXero, handleImport, getXeroConfig, createImport, updateImportXero, deleteImportXero} from '../../functions/xero';
import '../../css/ImportComponent.css';
import ImportHeaderComponent from '../page/ImportHeaderComponent';
import DropdownComponent from '../utilities/DropdownComponent';
import ListComponent from '../utilities/ListComponent';
import LoaderComponent from '../utilities/LoaderComponent';
import XeroLogo from '../../images/XeroLogo.png';
import { useTranslations  } from '../utilities/TranslationContext';

// Import the core library and icon packs you need
import { library } from '@fortawesome/fontawesome-svg-core';
import { faXmark, faChevronDown, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// Add the icons you will use to the library
library.add(faChevronDown, faXmark, faArrowLeft);

const XeroComponent = () => {
  const queryParams = new URLSearchParams(window.location.search);
  const [userCases, setUserCases] = useState([]);
  const [administrations, setAdministrations] = useState([]);
  const [budgetScenario, setBudgetScenario] = useState([]);
  const [importXero, setImportXero] = useState([]);
  const [isExtraContentVisible, setExtraContentVisible] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { getTranslation } = useTranslations();
  
  // Import_exact variables
  const [selectedCase, setSelectedCase] = useState(false);
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [selectedAdministration, setSelectedAdministration] = useState(false);
  const [selectedDataset, setSelectedDataset] = useState('act');
  const [selectedOpeningBalance, setSelectedOpeningBalance] = useState(1);
  const [selectedIgnoreYearEnd, setSelectedIgnoreYearEnd] = useState(0);

  useEffect(() =>{
  },[userCases, importXero, administrations, selectedAdministration, selectedCase, selectedYear, selectedDataset, selectedOpeningBalance, selectedIgnoreYearEnd]);

  useEffect(() =>{
    const queryParams = new URLSearchParams(window.location.search);
    if(queryParams.get("code")){
      xero_auth(queryParams.get("code"));
    }
    else{
      setIsLoading(true);
      init();
    }
    // setIsLoading(true);
    // init();
  }, []); // [] makes sure that this useEffect block only runs on the first render of the component
  async function xero_auth(auth_code){
    try { 
      var currentUser = await getCurrentUser();
      const response = await fetch('/xero/auth?auth_code='+auth_code+'&user_id='+currentUser);
      if (response.ok) {
        const responseData = await response.json();
        
        if(responseData){
          clearQueryParams(["code"]);
          await init();
          return responseData;
        }
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }
  async function xero_refresh(){
     try { 
      var currentUser = await getCurrentUser();

      const response = await fetch('/xero/refresh?user_id='+currentUser);
      if (!response.ok) {
        throw new Error('Request failed');
      }

      const responseData = await response.json();
      if (!responseData) {
        throw new Error('Empty response');
      }
      await init();

      return responseData;
    } catch (error) {
      get_xero();
      console.error('Error fetching data:', error);
    }
  }
  async function init(){
    var appUser = await getAppUser();
    
    if(appUser){
      if(appUser.integration_xero){  
        var cases = await getUserCases();
        var administration = await getXeroAdministration(appUser.user_id, cases);
        if(administration){
          setUserCases(cases);
          await fetchBudgetScenario();

        }
        else{
          xero_refresh();
        }
      }
      else{
        setIsLoading(false);
        alert("U heeft momenteel nog geen toegang tot de Xero-koppeling. Neem alstublieft contact op met Factview om de koppeling te activeren.");
        window.location.href = '/app';
      }
    }
    else{
      setTimeout(function(){
        return init();
      }, 300);
    }
  }

  async function get_xero(){
    window.location.href =`https://login.xero.com/identity/connect/authorize?response_type=code&client_id=0F4F98AE3C7847D89FDB5B054B1A62B6&redirect_uri=https://importmodule.factview.nl/app?import=xero&scope=openid profile email offline_access accounting.transactions accounting.contacts accounting.settings`;
  }

  // Fetch exactonline's budget scenario variables
  async function fetchBudgetScenario() {
    setBudgetScenario([{Description: "actuals/realisatiecijfers", Code: "act"}]);
  }
  async function getXeroAdministration(currentUser, cases){
    const response = await fetch('/xero/getAdministration', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({current_user: currentUser}),
    });
    if (response.ok) {
      const responseData = await response.json();
      if(responseData){
        var tenants = responseData.map(item => ({
          Description: item.tenantName,
          Code: item.tenantId
        }));
        
        setAdministrations(tenants);
        fetchImportXero(tenants, cases);
        return responseData;
      }
    }
  }

  async function fetchImportXero(offices, userCases){
    var divisionArray = [];
    offices.forEach(function(office){
      divisionArray.push(office.Code);
    });

    var importXero = await getImportXero(divisionArray, userCases);
    setIsLoading(false);
    setImportXero(importXero);
  }
  // Toggle On/Off create new import editor
  function toggleEditor(){
    const contentDiv = document.querySelector(".import-create-content");
    const newBtn = document.querySelector(".new-btn");
    const editorBtns = document.querySelector(".import-editor-btns");

    if(contentDiv.classList.contains("hidden")){
      contentDiv.classList.remove("hidden");
      newBtn.classList.add("hidden");
      editorBtns.classList.remove("hidden");
    }
    else{
      contentDiv.classList.add("hidden");
      newBtn.classList.remove("hidden");
      editorBtns.classList.add("hidden");
 
      resetAllInputs();
    }
  }

  // Toggle the additional import exact options (IgnoreYearEnd, Opening Balance)
  function toggleExtraOptions(){
    const extraContent = document.querySelector(".extra-content");
    const extraIcon = document.querySelector(".toggle-extra-icon");
    const createExtra = document.querySelector(".import-create-extra");
    
    if(!extraContent.classList.contains("visible")){
      extraContent.classList.add("visible");
      setExtraContentVisible(true);
      createExtra.style.maxHeight ="300px";
      createExtra.style.overflow = "visible";
    }
    else{
      extraContent.classList.remove("visible");
      extraIcon.classList.remove("fa-xmark");
      setExtraContentVisible(false);
      createExtra.style.maxHeight ="55px";
      createExtra.style.overflow = "hidden";
      resetExtraDropdown();
    }
  }

  // Resets all input and dropdown input fields to default
  function resetAllInputs(){
    setSelectedAdministration(false);
    setSelectedCase(false);
    setSelectedYear(new Date().getFullYear());
    setSelectedDataset(false);
    setSelectedIgnoreYearEnd(0);

    const resets = document.querySelector(".import-content").querySelectorAll(".reset-dropdown-btn");
    for(const reset of resets){
      reset.click();
    }
  }

  // Resets just the additional option dropdown elements
  function resetExtraDropdown(){
    setSelectedOpeningBalance(1);
    setSelectedIgnoreYearEnd(0);

  }

  // Handle the selectedYear onChange event
  async function handleChange(event){
    const newValue = event.target.value;
    setSelectedYear(newValue);
  }

  // Handle the dropdown onSelect events.
  function handleSelect(selectedOption){
    if(selectedOption.type=="case"){
      setSelectedCase(selectedOption.value);
    }
    else if(selectedOption.type=="administration"){
      setSelectedAdministration(selectedOption.value);
    }
    else if(selectedOption.type=="budgetscenario"){
      setSelectedDataset(selectedOption.value);
    }
    else if(selectedOption.type=="beginbalans"){
      setSelectedOpeningBalance(selectedOption.value);
    }
    else if(selectedOption.type=="memoriaal"){
      setSelectedIgnoreYearEnd(selectedOption.value);
    }
  } 
  
  async function getAdministrationDesc(code){
    for(const administration of administrations){
      if(administration.Code == code){
        return administration.Description;
      }
    }
    return null;
  }

  async function createImportXero(){
    var appUser = await getAppUser();
    var appIntegration = await getAppIntegration(appUser.integration_xero);
    var importConfig = {
      entiteit: selectedCase+"_1",
      jaar: selectedYear,
      office: selectedAdministration,
      office_description: await getAdministrationDesc(selectedAdministration),
      budgetScenario: selectedDataset,
      openingBalance: selectedOpeningBalance,
      ignoreYearEnd: selectedIgnoreYearEnd,
      factviewAccess: getCookie('factview_access'),
      factviewRefresh: getCookie('factview_refresh'),
    };

    await createImport(importConfig);
    await reloadImportXero();
  }

  // Update import exact factview and exactonline tokens
  async function updateImportXeroTokens(imp){
    if(imp){
      await fetch('/import_exact/updateImportExactTokens', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: imp.id,
          factview_access: getCookie('factview_access'),
          factview_refresh: getCookie('factview_refresh'),
          exact_access: getCookie('exact_access'),
          exact_refresh: getCookie('exact_refresh'),
        }),
      }); 
    }
  }

  async function reloadImportXero(){
    setIsLoading(true);
    await fetchImportXero(administrations, userCases);
  }

  // Redirect to home page event
  async function handleBackClicked(){
    window.location.href = '/app'
  }

  return (
    <div className="import-container">
      <ImportHeaderComponent
        title="Xero"
        logo={XeroLogo}
        subtitle={getTranslation('import_XeroSubtitle')}
      />
        <div className="import-component-container">
          <div className="import-component-content">
          <div className="import-content">
            <div className="import-create-content hidden">
              <div className="import-create-basic">
                <div className="case-content">
                  <p>{getTranslation('import_FVCase')}*</p>
                  <DropdownComponent
                    options={userCases.map((userCase) => ({ label: userCase.name, value: userCase.id, type:'case'}))}
                    defaultValue={{ label: getTranslation("import_SelectCase"), value: null, type:null}}
                    onSelect={handleSelect}
                    className="case"
                  />
                </div>
                <div className="administration-content">
                  <p>{getTranslation('import_XeroAdministration')}*</p>
                  <DropdownComponent
                    options={administrations.map((administration) => ({label: administration.Description, value: administration.Code, type:'administration'}))}
                    // options={[{label: administration.Description, value: administration.Code, type:'administration'}]}
                    onSelect={handleSelect}
                    defaultValue={{ label: getTranslation("import_SelectAdministratie"), value: null, type:null}}
                    className="administration"
                  />
                </div>
                <div className="jaar-content">
                  <p>{getTranslation('import_DropdownYear')}*</p>
                  <input
                    type="number"
                    min="1000" 
                    max="9999"
                    id="numberInput"
                    className="jaar-input"
                    value={selectedYear}
                    onChange={handleChange}
                  />
                </div>
                <div className="dataset-content">
                  <p>{getTranslation('import_DropdownDataset')}*</p>
                  <DropdownComponent
                    options={budgetScenario.map((scenario) => ({ label: scenario.Description, value: scenario.Code.trim(), type:'budgetscenario'}))}
                    onSelect={handleSelect}
                    defaultValue={{ label: getTranslation("import_SelectDataset"), value: null, type:null}}
                    className="dataset"
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="import-menubar">
            <button className="import-btn new-btn hover"  onClick={toggleEditor}>{getTranslation('import_CreateNew')}</button>            
            <div className="import-editor-btns hidden">
              <button className="import-btn submit-btn hover"  onClick={()=>{toggleEditor();createImportXero();}}>{getTranslation('import_Submit')}</button>
              <button className="import-btn cancel-btn hover"  onClick={toggleEditor}>{getTranslation("import_Cancel")}</button>
            </div>
         </div>
          <div className="import-list-content">
            <LoaderComponent isLoading={isLoading} paddingTop={"20px"}/>
            {Array.isArray(importXero) && importXero.length > 0 ? (
              <ListComponent data={importXero} reloadImport={reloadImportXero} handleImport={handleImport} updateImport={updateImportXero} deleteImport={deleteImportXero} importType={"xero"}/>
            ):("")}
          </div>
        </div>
      </div>
    </div>
  );
}

export default XeroComponent;
